export function roadmapPlanner() {
	// noop intentionally blank. Loaded via WRM
}

export function roadmapPlannerWRM() {
	return [
		'wr!com.atlassian.confluence.plugins.confluence-roadmap-plugin:roadmap-editor-resources-conf-frontend',
	];
}
